import script from "./LeadsView.vue?vue&type=script&setup=true&lang=js"
export * from "./LeadsView.vue?vue&type=script&setup=true&lang=js"

import "./LeadsView.vue?vue&type=style&index=0&id=70bdb27a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70bdb27a"]])

export default __exports__